import React from 'react'
import {
  Box,
  Card,
  Collapse,
  Divider,
  IconButton,
  Typography,
} from '@material-ui/core'
import {
  ChevronDown as ChevronDownIcon,
  ChevronUp as ChevronUpIcon,
} from 'react-feather'

import Loading from '../Loading'

import daiStarLogoBlue from 'images/dai-simple-logo-white.png'

import useStyles from './styles'

const DaiCard = ({
  children,
  title,
  containerPadding = 2,
  expandable = false,
  expanded = true,
  onToggleExpand,
  headerContent,
  loading = false,
  loadingProps = {},
}) => {
  const classes = useStyles()

  return (
    <Card>
      <Box
        className={classes.header}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box className={classes.titleContainer}>
          <Box>
            <img
              src={daiStarLogoBlue}
              alt="Dai Star Logo"
              className={classes.daiLogo}
            />
          </Box>
          <Box>
            <Typography variant="h3" className={classes.title}>
              {title}
            </Typography>
          </Box>
        </Box>

        {(expandable || headerContent) && (
          <Box className={classes.headerActions}>
            {headerContent}
            {expandable && (
              <IconButton onClick={onToggleExpand} color="inherit">
                {expanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
              </IconButton>
            )}
          </Box>
        )}
      </Box>

      <Divider />

      <Box p={loading ? 2 : 0}>
        {expandable && loading && (
          <Collapse in={expanded}>
            <Loading loading={loading} {...loadingProps} />
          </Collapse>
        )}
        {expandable && !loading && (
          <Collapse in={expanded}>
            <Box p={containerPadding}>{children}</Box>
          </Collapse>
        )}
        {!expandable && loading && (
          <Loading loading={loading} {...loadingProps} />
        )}
        {!expandable && !loading && <Box p={containerPadding}>{children}</Box>}
      </Box>
    </Card>
  )
}

export default DaiCard
